import React, { FC } from 'react'
import { Info } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../ui/tooltip'

interface CurrencyTooltipProps {
  currencyCode?: string
}

export const CurrencyTooltip: FC<CurrencyTooltipProps> = ({ currencyCode }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center gap-0.5">
          {currencyCode || 'USD'} <Info className="w-3" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-[400px]">
        <p className="leading-normal">
          Currency is set by country in the Profile tab. Changing country will require you to
          connect a new stripe account.
        </p>
      </TooltipContent>
    </Tooltip>
  )
}
